import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import {
    useAuth

} from '../../contexts/authContext';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
    //baseURL: "http://localhost:3000"

}))


export const AddDrillHoleModifierModal = (props) => {

    const [anumber, setAnumber] = useState();
    const [multiplier, setMultiplier] = useState();
    const [desc, setDesc] = useState();
    const [holeType, setHoleType] = useState();
    const [holeTypes, setHoleTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (props.show) {
            fetchHoleTypes();
            // Reset form when modal opens
            setAnumber('');
            setMultiplier(0.001);
            setDesc('');
            setHoleType('');
            setError('');
        }
    }, [props.show]);

    const fetchHoleTypes = async () => {
        try {
            const response = await GoldFinderApi.get('/admin/drill-hole-types');
            setHoleTypes(response.data.drillHoleTypes);
        } catch (error) {
            console.error('Error fetching drill hole types:', error);
        }
    };


    const storeReport = async () => {
        setLoading(true);
        setError('');
        
        try {
            const data = {
                anumber: anumber,
                multiplier: multiplier,
                description: desc,
                holetype: holeType
            };
            
            const response = await GoldFinderApi.post("/admin/modifiers/drillholes", {
                data
            });

            if (response.data.done) {
                props.onHide();
                
                // Refresh the table data if callback provided
                if (props.onSuccess) {
                    props.onSuccess();
                }
                
                // reset values back to default
                setAnumber('');
                setMultiplier(0.001);
                setDesc('');
                setHoleType('');
            }
        } catch (error) {
            console.error('Error creating drill hole modifier:', error);
            
            if (error.response && error.response.status === 409 && error.response.data.isDuplicate) {
                setError(error.response.data.error);
            } else {
                setError('Failed to create drill hole modifier. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add Drill Hole Modifier
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <Form.Group
                    className="mb-3"
                    controlId="anumber"
                >
                    <Form.Label>A Number <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control 
                        type="text"
                        value={anumber}
                        onChange={e => setAnumber(e.target.value)}
                        placeholder="Enter A Number (e.g. A12345)"
                        required 
                    />
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="multiplier"
                >
                    <Form.Label>Multiplier <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control 
                        type="number"
                        step="0.000001"
                        value={multiplier}
                        onChange={e => setMultiplier(parseFloat(e.target.value))}
                        placeholder="Enter multiplier value"
                        required 
                    />
                    <Form.Text className="text-muted">
                        Gold values will be multiplied by this factor. Use values like 0.001 to reduce values or 10 to increase them.
                    </Form.Text>
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="holetype"
                >
                    <Form.Label>Hole Type <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Select 
                        value={holeType}
                        onChange={e => setHoleType(e.target.value)}
                        required
                    >
                        <option value="">Select hole type...</option>
                        {holeTypes.map(type => (
                            <option key={type.holetype} value={type.holetype}>
                                {type.nicename}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Text className="text-muted">
                        Select 'ALL' to apply to all hole types for this A Number, or choose a specific hole type.
                    </Form.Text>
                </Form.Group>

                <Form.Group
                    className="mb-3"
                    controlId="description"
                >
                    <Form.Label>Description</Form.Label>
                    <Form.Control 
                        as="textarea"
                        rows={3}
                        value={desc}
                        onChange={e => setDesc(e.target.value)}
                        placeholder="Optional description for this modifier..."
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide} disabled={loading}>
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    onClick={() => storeReport()} 
                    disabled={loading || !anumber || !multiplier || !holeType}
                >
                    {loading ? 'Adding...' : 'Add Modifier'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}